import React from 'react'
import './flyout.scss';

const Flyout = (props) => {
  return (
    <div className={`flyout ${props.isOpen && 'flyout--open'}`}>
      <button className='flyout__close' onClick={props.closeContactForm}>Close</button>
      <div className="flyout__inner">
        {props.children}
      </div>
    </div>
  )
}

export default Flyout
